import React, { useEffect, useState } from 'react';

import './FancyBookView.scss';
import { connect } from 'react-redux';
import { RootState } from '../../../models/RootState';
import { UserBet } from '../../../models/ExchBetSlip';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import { useTranslation } from '../../../hooks/useTranslation';
import { FancyMarkets } from '../../../models/EventData';

type PropsType = {
  openBets: UserBet[];
  exposureMap?: any;
  fancyMarket?: FancyMarkets;
};

const FancyBookView: React.FC<PropsType> = (props) => {
  const { t } = useTranslation();
  const { openBets, exposureMap, fancyMarket } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [runsRiskMap, setRunsRiskMap] = useState<any>({});


  const getRiskValue = () => {
    let probableRunsList: any = [];
    if (exposureMap) {
      if (fancyMarket?.oddType === 'ODD_EVEN') {
        const noOutcome = Number(fancyMarket?.noValue);
        const yesOutcome = Number(fancyMarket?.yesValue);
        const marketBets = openBets.filter(
          (bet) => bet.marketId === fancyMarket?.marketId && bet.marketType === 'FANCY'
        );

        let oneOrLessRisk = 0;
        let twoOrMoreRisk = 0;

        marketBets.forEach((bet) => {
          const stake = Number(bet.stakeAmount) || 0;
          const oddRate = Number(bet.oddValue) || 0;
          const profit = (oddRate * 0.01) * stake;
          const isNoSelection = Number(bet.sessionOutcome) === noOutcome;
          const isYesSelection = Number(bet.sessionOutcome) === yesOutcome;

          // Odd/even UI only places BACK bets; ignore non-BACK bets in this display calc.
          if (!isNoSelection && !isYesSelection) return;
          if (bet.betType !== 'BACK') return;

          if (isNoSelection) {
            oneOrLessRisk += profit;
            twoOrMoreRisk -= stake;
          } else {
            twoOrMoreRisk += profit;
            oneOrLessRisk -= stake;
          }
        });

        setRunsRiskMap({
          '1 or less': {
            runnerId: '1 or less',
            userRisk: oneOrLessRisk,
          },
          '2 or more': {
            runnerId: '2 or more',
            userRisk: twoOrMoreRisk,
          },
        });
        return;
      }

      probableRunsList = Object.values(exposureMap).sort((a: any, b: any) => Number(b) - Number(a));
      let runsMap: any = {};
      for (let pr of probableRunsList) {
        runsMap[pr['runnerId']] = pr;
      }
      setRunsRiskMap(runsMap);
    }
  };

  useEffect(() => {
    setLoading(true);
    getRiskValue();
    setLoading(false);
  }, [openBets, exposureMap, fancyMarket]);

  return (
    <div className="fancy-book-table-ctn">
      {loading ? null : (
        <>
          {exposureMap ? (
            <TableContainer component={Paper}>
              <Table className="fancy-book-table">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("sports.runnerName")}</TableCell>
                    <TableCell>{t("sports.profitLoss")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(runsRiskMap)
                    .sort((a, b) => {
                      if (fancyMarket?.oddType === 'ODD_EVEN') {
                        if (a === '1 or less') return -1;
                        if (b === '1 or less') return 1;
                        return 0;
                      }
                      return Number(a) - Number(b);
                    })
                    .map((run: any, idx) => (
                      <TableRow key={idx}>
                        <TableCell key={'row-' + idx + 'cell-1'}>
                          {fancyMarket?.oddType === 'ODD_EVEN'
                            ? run
                            : idx === 0
                              ? `${run} ${t("sports.orLess")}`
                              : idx === Object.keys(runsRiskMap).length - 1
                                ? `${run} ${t("sports.orMore")}`
                                : run}
                        </TableCell>
                        <TableCell
                          key={'row-' + idx + 'cell-2'}
                          className={
                            runsRiskMap[run]?.userRisk > 0
                              ? 'profit'
                              : runsRiskMap[run]['userRisk'] < 0
                                ? 'loss'
                                : ""
                          }
                        >
                          {runsRiskMap[run]['userRisk'] > 0
                            ? '+' +
                            Number(runsRiskMap[run]['userRisk']).toFixed(2)
                            : Number(runsRiskMap[run]['userRisk']).toFixed(2)}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <div className="no-data">{t("sports.messages.noDataToDisplay")}</div>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    openBets: state.exchBetSlip.openBets,
  };
};

export default connect(mapStateToProps)(FancyBookView);
